module.exports = __webpack_public_path__ + "img/1F1F8-1F1ED.6b7ae56c.svg";